
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Item": [
      "Process",
      "Run",
      "Sink",
      "Source"
    ],
    "MoveItemOnTimelineError": [
      "OptimisticConcurrencyError"
    ]
  }
};
      export default result;
    